import { Component, OnInit, OnDestroy, Input, Output,EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import { NotificationInterface } from '@core/store/models/notifications.interface';
import { NotificationsContextEnum } from '@core/store/models/notifications.enum';

import { NotificationsService } from '@core/services/notifications/notifications.service';
import { RecorderService } from '@core/services/recorder/recorder.service';
// import { ClickEventManagerService } from '@core/services/click-manager/click-manager.service';


@Component({
    selector: 'core-notifications-helpers-action-record-start',
    templateUrl: './record-start.component.html',
    styleUrls: ['./record-start.component.scss']
})
export class CoreNotificationsHelpersActionRecordStartComponent implements OnInit, OnDestroy {
    public readonly NOTIFICATION_TYPES = NotificationsContextEnum;

    @Input() notification: NotificationInterface;

    constructor(private notsSrv: NotificationsService, 
                private recorderSrv: RecorderService,
                // private clickSrv: ClickEventManagerService,
                private router: Router) {
    }

    ngOnInit(){
        console.log(" notification  item ",this.notification)
    }

    ngOnDestroy(): void {
    }

    stop():void {
        // quit the notification
        this.notsSrv.dismissNotification(this.notification.id);
        // stop the recording in recorder store
        this.recorderSrv.stopRecording();
        // navigate to url given in the notification
        if(this.notification.data.details.hasOwnProperty('url') && this.notification.data.details.url != '')
            this.router.navigate([this.notification.data.details.url]);

        // NOTE about ClickEventManagerService: removed this trigger and 
        //     manage the action modal player by the store record status instead of click
        // this.clickSrv.triggerClickEvent( this.NOTIFICATION_TYPES.ACTION_RECORD_STOP);
        
    }

}
